<!-- <div>
<span *ngFor="let tag of this.tags" style='margin-right:5px;'>
  {{tag}}<span class='k-icon k-i-close' (click)='this.deleteTag(tag)'></span>
</span>
</div> -->
<div class="flow-tags-wrapper">
  <div style='margin-top:10px;'>

    <kendo-multiselect [data]="flowTags" [allowCustom]="true" (valueChange)="onTagsChange($event)" [value]="this.tags">
    </kendo-multiselect>


    <!-- #<input kendoTextBox [(ngModel)]="newTag" (keyup.enter)='this.addTag()' /><span class='k-icon k-i-plus' (click)='this.addTag()'>x</span> -->
  </div>
  <div style='margin-top:10px;'>
    <button kendoButton (click)="saveTags()" themeColor="primary" [disabled]='this.isSaving'>Save Tags</button>
  </div>

  @if (this.isSaving) {
    <div class="k-i-loading"></div>
  }
</div>
